module.exports = __webpack_public_path__ + "static/media/step-segment-es.a189389c.png";